<template>
  <div class="col px-0 px-md-3">
    <ColorPointsHeader :message="pinkHeaderMessage" color="rgba(227, 13, 104, 0.5)" />
    <div id="saisieContact"
         class="center py-5 px-2">
      <div class="text-center font-weight-bold m-5" v-if="formSent" v-html="focus.paragraphe2 ? focus.paragraphe2.texte : ' '"></div>
      <b-form v-else @submit.stop.prevent="checkErrors"
              class="row w-100 m-0">
        <div class="col-12 col-md-6">
          <div class="row">
            <div class="col-6 p-2 p-lg-3">
              <div class="champs h-100">
                <b-form-group id="nomGroup"
                              class="d-flex flex-column justify-content-between h-100 m-0"
                              label="Nom"
                              label-for="nom"
                              label-class="required text-secondary"
                              :invalid-feedback="errorMessage"
                              :state="error.nom">
                  <b-form-input id="nom"
                                name="nom"
                                placeholder="Votre nom"
                                v-model="fiche.nom"
                                :state="error.nom"></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="col-6 p-2 p-lg-3">
              <div class="champs h-100">
                <b-form-group id="prenomGroup"
                              class="d-flex flex-column justify-content-between h-100 m-0"
                              label="Prénom"
                              label-for="prenom"
                              label-class="required text-secondary"
                              :invalid-feedback="errorMessage"
                              :state="error.prenom">
                  <b-form-input id="prenom"
                                name="prenom"
                                placeholder="Votre prénom"
                                v-model="fiche.prenom"
                                :state="error.prenom"></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="col-6 p-2 p-lg-3">
              <div class="champs h-100">
                <b-form-group id="emailGroup"
                              class="d-flex flex-column justify-content-between h-100 m-0"
                              label="Email"
                              label-for="email"
                              label-class="required text-secondary"
                              :invalid-feedback="errorMessage"
                              :state="error.email">
                  <b-form-input id="email"
                                name="email"
                                placeholder="Votre email"
                                v-model="fiche.email"
                                :state="error.email"
                                type="email"></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="col-6 p-2 p-lg-3">
              <div class="champs h-100">
                <b-form-group id="telephoneGroup"
                              class="d-flex flex-column justify-content-between h-100 m-0"
                              label="Téléphone"
                              label-for="telephone"
                              label-class="text-secondary"
                              :invalid-feedback="errorMessage"
                              :state="error.telephone">
                  <b-form-input id="telephone"
                                name="telephone"
                                type="tel"
                                pattern="^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$"
                                placeholder="Votre numéro"
                                v-model="fiche.telephone"
                                :state="error.telephone"></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="col-6 p-2 p-lg-3">
              <div class="champs h-100">
                <label for="adresse"
                      class="text-secondary">Adresse</label>
                <AutoCompleteGouvApi intitule="adresse" autoCompType="adresse" variant="secondary" @changedGPSData="changeGPSData"></AutoCompleteGouvApi>
                <b-form-invalid-feedback :state="error.lieu">{{ errorMessage }}
                </b-form-invalid-feedback>
              </div>
            </div>
            <div class="col-6 p-2 p-lg-3">
              <div class="champs h-100">
                <b-form-group id="cpGroup"
                              class="d-flex flex-column justify-content-between h-100 m-0"
                              label="Votre code postal"
                              label-for="cp"
                              label-class="text-secondary">
                  <b-form-input id="cp"
                                name="cp"
                                type="text"
                                placeholder="Votre code postal"
                                v-model="fiche.codePostal"></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="col-6 p-2 p-lg-3">
              <div class="champs h-100">
                <label for="ville"
                      class="text-secondary">Ville</label>
                <AutoCompleteGouvApi intitule="ville" variant="secondary" :ville="fiche.ville" :cp="fiche.codePostal" @changedGPSData="changeGPSData"></AutoCompleteGouvApi>
                <b-form-invalid-feedback :state="error.lieu">{{ errorMessage }}
                </b-form-invalid-feedback>
              </div>
            </div>
            <div class="col-6 p-2 p-lg-3">
              <div class="champs h-100">
                <label for="pays"
                      class="text-secondary">Pays</label>
                <AutoCompleteGouvApi intitule="pays" :pays="fiche.pays" autoCompType="pays" @changedGPSData="changeGPSData"></AutoCompleteGouvApi>
                <b-form-invalid-feedback :state="error.lieu">{{ errorMessage }}
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row h-100 p-2 p-lg-3">
            <div class="col-12 champs">
              <b-form-group id="questions"
                            class="d-flex flex-column justify-content-between h-100 m-0"
                            label="Vos questions"
                            label-for="questions"
                            label-class="required text-secondary"
                            :invalid-feedback="errorMessage"
                            :state="error.questions">
                <b-form-textarea id="questions"
                                name="questions"
                                v-model="fiche.questions"
                                placeholder="Saisissez votre message ici"
                                rows="7"
                                max-rows="10"
                                :state="error.questions"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-12 px-0 py-2 py-lg-3">
              <b-form-checkbox id="conditionsRgpd"
                              v-model="fiche.rgpd"
                              name="conditionsRgpd"
                              class="pl-4 pr-0 py-0"
                              value="1"
                              unchecked-value="0">
              <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ' '"></p>
                <strong>* Champs obligatoires</strong>
              </b-form-checkbox>
              <b-form-invalid-feedback :state="error.rgpd">{{ errorMessage }}
              </b-form-invalid-feedback>
            </div>
            <div class="col-12 px-0 d-flex flex-row-reverse align-items-end">
              <b-button type="submit"
                        id="envoyer"
                        variant="secondary"
                        class="bold small-ls text-uppercase py-1 px-5"
                        squared>Envoyer</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DataApi from '../../dependencies/index'
import { FormGroupPlugin, FormPlugin, FormInputPlugin, FormTextareaPlugin, FormCheckboxPlugin, InputGroupPlugin, ButtonPlugin } from 'bootstrap-vue'
import { getFocus } from '../../mixins/getFocus'

Vue.use(FormGroupPlugin)
Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ButtonPlugin)

export default {
  name: 'Contact',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader'),
    AutoCompleteGouvApi: () => import('../../components/AutoCompleteGouvApi')
  },
  data () {
    return {
      pinkHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      fiche: {
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        adresse: '',
        codePostal: '',
        ville: '',
        pays: '',
        questions: '',
        rgpd: '',
        type: 'contact',
        destinataire: 'ti'
      },
      error: {
        nom: null,
        prenom: null,
        questions: null,
        rgpd: null,
        email: null
      },
      formSent: false,

      /* message d'erreur affiché pour un champs requis vide */
      errorMessage: 'Ce champs est requis',
      focus: {}
    }
  },
  methods: {
    checkErrors () {
      this.error.nom = (!!this.fiche.nom)
      this.error.prenom = (!!this.fiche.prenom)
      this.error.questions = (!!this.fiche.questions)
      this.error.email = (!!this.fiche.email)
      this.error.rgpd = (!!this.fiche.rgpd && this.fiche.rgpd !== '0')
      let stop = false
      Object.values(this.error).forEach((value) => {
        if (value === false) {
          stop = true
        }
      })
      if (stop) {
        setTimeout(() => {
          Object.keys(this.error).forEach((key) => {
            this.error[key] = null
          })
        }, 3000)
      } else {
        this.addDemande()
      }
    },
    async addDemande () {
      const demandeToSend = this.fiche
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.createRecord(
        'W_DemandeContact', 
        demandeToSend,
        [{
          name: 'validerFormulaire',
          type: 'postrequest'
        }]
      )
      .then((response) => {
        console.log(response)
        this.formSent = true
      })
    },
    changeGPSData (data) {
      if (data.cp !== '' && data.cp !== undefined) {
        this.fiche.adresse = data.adresse
      }
      if (data.cp !== '' && data.cp !== undefined) {
        this.fiche.codePostal = data.cp
      }
      if (data.commune !== '' && data.commune !== undefined) {
        this.fiche.ville = data.commune
      }
      this.fiche.pays = data.pays
    }
  },
  async beforeMount () {
    await this.getFocus('Tolus Immo', 'Contact')
      .then(res => {
        this.focus = res
          this.pinkHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
          this.pinkHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  }
}
</script>
<style lang="scss" scoped>

  .champs {
    border: 1px solid var(--gray) !important;
    padding: 1rem !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
  }

  .form-control {
    background-color: transparent !important;
    border: none !important;
    color: var(--secondary) !important;
    font-size: 1rem !important;
  }

  ::v-deep .required::after {
    content:" *";
    font-size: 80%;
    vertical-align: super;
  }

  .autoCompleteInput input, .autoCompleteInput .input-group {
    height: 100% !important;
    border-radius: 0;
  }
  .autoCompleteInput .form-control {
    border: none !important;
    color: var(--secondary) !important;
    font-size: 1rem !important;
  }
  #envoyer {
    height: 2.5rem !important;
  }
  ::v-deep .autoCompleteInput .form-control {
    border: none !important;
    font-size: 1rem !important;
    input.form-control {
      color: var(--secondary) !important;
    }
  }
  ::v-deep ::placeholder {
    color: #C0C4CC !important;
    font-size: 1rem !important;
  }
</style>
